import React from "react";
import "../common.css";

const Title = ({ title, color }) => {
  return (
    <div className="mb-5">
      <div className="title" style={{ color: color }}>
        {title}
      </div>
      <div style={{ border: `2px solid ${color}`, width: 90 }}></div>
    </div>
  );
};

export default Title;
